export default __webpack_public_path__ + "47d6a758bd2652a210c8fcae64c255aa.png";